import {
    ClusterOutlined, ScheduleOutlined, UnorderedListOutlined
} from "@ant-design/icons";
// import {  TaskPage } from "../Pages";
import { CustomersPage, PlanningPage, ObjectivePage , UsagePage  } from "../Pages";
import { AllTaskPage, TodayTaskPage, ManagementTaskPage } from "../Pages";
import { TeamPage } from "../Pages";
import { DashboardPage } from "../Pages";
import { IconAgency, ISidebarItemProps } from "@esg/ui";




const billSidebarConstants: ISidebarItemProps[] = [
    {
        label: "Invoice",
        Icon: <IconAgency.Menu.Invoice />,
        path: 'bill/invoice',
        page: <TodayTaskPage />

    },
    {
        label: "Subscription",
        Icon: <IconAgency.Menu.Subscription />,
        path: 'bill/subscription',
        page: <AllTaskPage />

    },
    {
        label: "Payment",
        Icon: <IconAgency.Menu.Payment />,
        path: 'bill/payment',
        page: <ManagementTaskPage />
    },
    {
        label: "Revenue",
        Icon: <IconAgency.Menu.Revenue />,
        path: 'bill/revenue',
        page: <ManagementTaskPage />
    }
];

const partnerSidebarConstants: ISidebarItemProps[] = [
    {
        label: "Partner",
        Icon: <IconAgency.Menu.Partner />,
        path: 'bill/invoice',
        page: <TodayTaskPage />

    },
    {
        label: "Commission",
        Icon: <IconAgency.Menu.Commission />,
        path: 'bill/subscription',
        page: <AllTaskPage />

    },
    {
        label: "Performance",
        Icon: <IconAgency.Menu.Performance />,
        path: 'bill/payment',
        page: <ManagementTaskPage />
    }
];


const saleSidebarConstants: ISidebarItemProps[] = [
    {
        label: "Pipeline",
        Icon: <IconAgency.Menu.Pipeline />,
        path: 'sale/pipeline',
        page: <TodayTaskPage />

    },
    {
        label: "Deals",
        Icon: <IconAgency.Menu.Deal />,
        path: 'sale/deals',
        page: <AllTaskPage />

    },
    {
        label: "Quotes",
        Icon: <IconAgency.Menu.Quote />,
        path: 'sale/quotes',
        page: <ManagementTaskPage />
    }
];

const contractSidebarConstants: ISidebarItemProps[] = [
    {
        label: "Contracts",
        Icon: <ScheduleOutlined />,
        path: 'contract',
        page: <TodayTaskPage />

    },
    {
        label: "Active",
        Icon: <UnorderedListOutlined />,
        path: 'contract/active',
        page: <AllTaskPage />

    },
    {
        label: "Renew",
        Icon: <ClusterOutlined />,
        path: 'contract/renew',
        page: <ManagementTaskPage />
    }
];


const customerSidebarConstants: ISidebarItemProps[] = [
    {
        label: "Customers",
        Icon: <IconAgency.Menu.UserDt />,
        path: 'customer/customers',
        page: <CustomersPage />
    },
    {
        label: "Usages",
        Icon: <IconAgency.Menu.Actions />,
        path: 'customer/subscriptions',
        page: <UsagePage />
    },
    {
        label: "Leads",
        Icon: <IconAgency.Menu.Lead />,
        path: 'customer/leads',
        page: <PlanningPage />
    },
    {
        label: "Segments",
        Icon: <IconAgency.Menu.Segment />,
        path: 'customer/segments',
        page: <ObjectivePage />
    },
];

const teamSidebarConstants: ISidebarItemProps[] = [
    {
        label: "Team",
        Icon: <IconAgency.Menu.Team />,
        path: 'team',
        page: <TeamPage />
    }
];

const dashboardSidebarConstants: ISidebarItemProps[] = [
    {
        label: "Dashboard",
        Icon: <IconAgency.Menu.Home />,
        path: '',
        page: <DashboardPage />
    }
];

const sidebarConst = [
    ...customerSidebarConstants,
    {
        path: 'customer/subscriptions/*',
        page: <UsagePage />
    },
    
    ...saleSidebarConstants,
    ...teamSidebarConstants,
    ...dashboardSidebarConstants,
    ...contractSidebarConstants,
    ...billSidebarConstants,
    ...partnerSidebarConstants
];

export {
    customerSidebarConstants,
    saleSidebarConstants,
    teamSidebarConstants,
    dashboardSidebarConstants,
    contractSidebarConstants,
    billSidebarConstants,
    partnerSidebarConstants,
    sidebarConst
}


